import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import Footer from "../components/Footer";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Bem-vindo de volta, ${u.name}.`);
      if (u.is_admin) {
        navigate("/admin");
      } else {
        navigate(u.onboarding_complete ? "/discover" : "/onboarding");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível entrar.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#0C0E12]" data-testid="login-page">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 justify-center mb-10">
            <Heart className="w-5 h-5 text-[#C5A880]" />
            <span className="font-display text-2xl">Soulmatch</span>
          </Link>

          <div className="bg-[#161920] border border-white/5 rounded-2xl p-10">
            <span className="label-uppercase">Entrar</span>
            <h1 className="font-display text-3xl mt-3 mb-8">Bem-vindo de volta</h1>

            <form onSubmit={submit} className="space-y-6">
              <div>
                <label className="text-xs text-[#A29F9B]">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  className="input-elegant"
                  placeholder="o-teu-email@exemplo.pt"
                  data-testid="login-email"
                />
              </div>
              <div>
                <div className="flex items-center justify-between">
                  <label className="text-xs text-[#A29F9B]">Palavra-passe</label>
                  <Link to="/esqueci-password" className="text-xs text-[#C5A880] hover:underline" data-testid="login-forgot">
                    Esqueceste-te?
                  </Link>
                </div>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  className="input-elegant"
                  placeholder="••••••••"
                  data-testid="login-password"
                />
              </div>
              <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
                {busy ? "A entrar..." : "Entrar"}
              </button>
            </form>

            <p className="text-sm text-[#A29F9B] mt-6 text-center">
              Ainda não tens conta?{" "}
              <Link to="/register" className="text-[#C5A880] hover:underline" data-testid="login-go-register">
                Criar agora
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
